import * as React from 'react';
import { FieldInputProps } from 'react-final-form';

interface TFFTextInputProps {
  inputId: string;
  labelText: string;
  inputFromRedux: FieldInputProps<any>;
  error?: boolean;
  errorText?: string;
  disabled?: boolean;
  isBookingId?: boolean;
  required?: boolean;
  helperText?: string;
  maxLength?: number;
  extraStyle?: React.CSSProperties;
}

export const TFFTextInput: React.FC<TFFTextInputProps> = ({
  inputId,
  labelText,
  disabled,
  inputFromRedux,
  isBookingId,
  required,
  helperText,
  maxLength,
  error,
  errorText,
  extraStyle,
}) => {
  return (
    <label
      style={{ ...extraStyle }}
      htmlFor={inputId}
      className={`input input-text${disabled ? ' disabled' : ''} ${error ? ' error' : ''}`}
    >
      <span className="label">{labelText}</span>
      <span className="helpertext">{helperText}</span>
      <span className="group" data-label="">
        <input
          id={inputId}
          type="text"
          disabled={disabled}
          required={required}
          maxLength={maxLength}
          aria-invalid={'true'}
          {...inputFromRedux}
          className={`${isBookingId ? 'tff-id-input' : ''}`}
        />
      </span>
      {error && <p className="message">{errorText}</p>}
    </label>
  );
};

export default TFFTextInput;
